/**
 * View-mode visibility for bag line fields — mirrors DynamicForm hidden_if on repeater children.
 * fd keys match form: BagStatus (bag status NAME), BagCaseType (case type string), Type, ReceiveDate, ForwardDate, Action (action id or object).
 */

function bagStatusName(bag) {
  return bag?.bag_status?.name ?? bag?.bagStatus?.name ?? "";
}

function matchesHiddenIfBagStatus(bag, ...statuses) {
  const name = bagStatusName(bag);
  return statuses.some((s) => String(name).toUpperCase() === String(s).toUpperCase());
}

export function shouldShowBagFieldInCaseView(label, bag, caseType) {
  const ct = String(caseType || "");
  const hasAction =
    bag?.action_id != null ||
    (bag?.action != null && (typeof bag.action === "object" ? bag.action.id != null : true));

  switch (label) {
    case "Tag Number":
    case "Bag Status":
      return true;
    case "Arriving Flight":
      if (matchesHiddenIfBagStatus(bag, "TRACING")) return false;
      if (["DPR", "OHD", "UNCLAIMED"].includes(ct)) return false;
      return true;
    case "Receive Date":
      if (matchesHiddenIfBagStatus(bag, "TRACING", "LOCATED")) return false;
      return true;
    case "Received Flight":
      if (matchesHiddenIfBagStatus(bag, "TRACING", "LOCATED")) return false;
      if (["UNCLAIMED", "OHD"].includes(ct)) return false;
      return true;
    case "Forward Date":
    case "Forward Flight":
    case "Forward Type":
    case "Rush Tag Number":
      return matchesHiddenIfBagStatus(bag, "FORWARDED");
    case "Deliver Date":
    case "Delivery Name":
    case "Delivery Contact":
    case "Delivery Identity":
    case "Delivery Condition":
    case "Delivery Signature":
      return matchesHiddenIfBagStatus(bag, "DELIVERED");
    case "Damage Bag Receive Date":
      if (ct !== "DPR") return false;
      if (!hasAction) return false;
      return true;
    default:
      return true;
  }
}

export function shouldShowClaimFields(caseType) {
  return String(caseType || "") === "CLAIMS";
}
